// src/pages/TransferRecord/TransferRecordSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { deleteTransfer, fetchTransferRecord } from "./TransferRecordThunk";

const initialState = {
  list: [],
  loading: false,
  accessType: "WRITE",
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
  },
};

const transferRecordSlice = createSlice({
  name: "transferRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTransferRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchTransferRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteTransfer.fulfilled, (state, action) => {
        state.list = state.list.filter(r => r.t_id !== action.payload.t_id);
      });
  },
});

export const { setFilters } = transferRecordSlice.actions;
export default transferRecordSlice.reducer;
